import React, { useEffect, useState } from "react";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { notification, Modal } from "antd";
import { useQueryParams, withDefault, StringParam } from "use-query-params";
import Requester from "common/network/http/Request";
import endpoints from "configs/endpoints";

function AgentConfirmation() {
  const [isJoining, setIsJoining] = useState(false);
  const [query, setQuery] = useQueryParams({
    ainv: withDefault(StringParam, null),
  });

  useEffect(() => {
    if (query.ainv) loadInvitation(query.ainv);
  }, [query.ainv]);

  const loadInvitation = async (inviteCode) => {
    try {
      const res = await Requester.get(endpoints.agent.getInvitation(inviteCode), undefined, undefined, false, false, true);

      if (res.status === 200 && res.data) {
        const { inviter } = res.data;

        Modal.confirm({
          centered: true,
          icon: <CheckCircleTwoTone twoToneColor="var(--success-color)" />,
          title: "Become an agent!",
          content: (
            <React.Fragment>
              <div className="ui-thankyou">
                You've been invited to become an agent of <a href={`https://${inviter.domain}`} target="_blank">{inviter.domain}</a> by {inviter.full_name}.
              </div>
              <p>
                {`Are you sure to want to join ${inviter.first_name}'s team?`}
              </p>
            </React.Fragment>
          ),
          cancelText: "Cancel",
          okText: `Join ${inviter.domain}`,
          okButtonProps: { loading: isJoining },
          onOk: () => confirmInvitation(inviter.domain),
          onCancel: () => {
            setQuery({ ainv: undefined });
          },
        });
      }
    } catch (err) {
      notification.error({
        message: "Invalid Invitation",
        description: "Your invitation has been expired or is invalid.",
      });
    }
  };

  const confirmInvitation = async (agentDomain) => {
    setIsJoining(true);

    try {
      const res = await Requester.put(endpoints.agent.acceptInvitation(query.ainv), null, undefined, false, false, true);

      if (res.status === 202) {
        notification.success({
          message: "Congratulations!",
          description: "You have now become an agent.",
        });

        if (window.location.host !== agentDomain) {
          notification.info({
            message: "Heads Up!",
            description: "Taking you to the Alliance Partner site in 5s.",
          });

          setTimeout(() => {
            window.location.href = `https://${agentDomain}`;
          }, 5000);
        }

        setQuery({ ainv: undefined });
      }
    } catch (err) {
      notification.error({
        message: "Something went wrong!",
        description: err.message,
      });
    } finally {
      setIsJoining(false);
    }
  };

   return null;
}

export default AgentConfirmation;
